'use client';

import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import type { OtroFeoroTO } from '@/types/goldDate';
import { cn } from '@/utils';

interface TournamentItemProps {
  item: OtroFeoroTO;
  index: number;
  className?: string;
}

export const GoldListItem = ({
  item,
  index,
  className,
}: TournamentItemProps) => {
  const navigate = useNavigate();
  const { updateTourney } = useTourney();

  const handleViewTournament = () => {
    updateTourney({
      id: item.idTA,
    });
    navigate(ROUTES.goldDate.ranking, { state: true });
  };

  return (
    <div
      className={cn(
        'flex items-center content-between justify-between px-7 py-3 bg-white lg:bg-transparent',
        className
      )}
    >
      <div className="flex items-center">
        <div className="w-9 h-9 lg:w-10 lg:h-10 mr-4">
          <div
            className={cn(
              'rounded-full text-gdt-blue bg-gdt-blue-light2 w-9 h-9 lg:w-10 lg:h-10 font-bold text-lg flex justify-center items-center'
            )}
          >
            <span>{index}</span>
          </div>
        </div>
        <p className="font-bold">{item.nombreTA}</p>
      </div>
      <Button
        className="w-[115px] h-[36px] px-0 text-xs border-none"
        type="button"
        variant="primary"
        onClick={handleViewTournament}
      >
        Ver Torneo
      </Button>
    </div>
  );
};
